import Vue from 'vue'

Vue.mixin({
	data() {
		return {
			innerWidth: window.innerWidth
		}
	},
	computed: {
		isDesktop() {
			return this.innerWidth >= 1024
		},
		isMobile() {
			return this.innerWidth <= 1024
		}
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.innerWidth = window.innerWidth
		})
	},
})
